import React from 'react';
import { SolidStatusPill } from '@odo/shared-ui';

interface StageChipProps {
    stage: string | null | undefined;
}

/**
 * Same solid, colour-hashed status pill the admin work-queue uses for its
 * ManufacturerStatusPill (see packages/shared-ui/src/components/SolidStatusPill.tsx).
 * Requested so the appointments modal shows patient status identically to
 * the admin tool. `treatmentStatus` values are already practice-facing
 * labels (backend/src/services/workflow/statuses/external-status.ts), so no
 * humanizing is needed; the raw value both displays and drives the colour
 * hash.
 */
const StageChip: React.FC<StageChipProps> = ({ stage }) => {
    if (!stage) return null;
    return <SolidStatusPill value={stage} />;
};

export default StageChip;
